// Mel escorrendo no topo da tela de planos (AC-237): desce devagar do topo da janela até a
// base do logo e um brilho atravessa o mel de tempos em tempos. Só decoração (aria-hidden);
// com "reduzir movimento" no sistema, aparece parado no lugar final.
import { useId } from 'react';

/**
 * Borda de baixo: a da primeira versão, desenhada na proporção da área (400 x 122, sem achatar),
 * suavizada, com um arco sobre o logo (sem encostar nele) e uma ondulação larga no topo do arco.
 */
const HONEY_PATH =
  'M0,0 H400 V35.3 C399.3,35.3 397.3,35.5 396,35.6 C394.7,35.6 393.3,35.7 392,35.8 C390.7,35.8 389.3,35.9 ' +
  '388,36 C386.7,36.1 385.4,36.2 384,36.4 C382.7,36.7 381.4,36.9 380.2,37.4 C378.9,37.8 377.7,38.3 376.5,39 ' +
  'C375.4,39.7 374.3,40.5 373.3,41.4 C372.3,42.3 371.5,43.3 370.7,44.4 C369.8,45.4 369.1,46.5 368.4,47.7 ' +
  'C367.7,48.8 367.1,50 366.4,51.2 C365.8,52.3 365.2,53.5 364.7,54.7 C364.1,55.9 363.5,57.1 363,58.4 ' +
  'C362.5,59.6 362,60.8 361.5,62.1 C361,63.3 360.5,64.6 360,65.8 C359.5,67 359,68.3 358.4,69.4 C357.8,70.6 ' +
  '357.1,71.8 356.4,72.9 C355.6,74 354.7,75 353.6,75.8 C352.6,76.6 351.4,77.3 350.1,77.7 C348.9,78 ' +
  '347.4,78.2 346.2,78 C344.9,77.8 343.6,77.3 342.5,76.6 C341.4,75.9 340.5,74.8 339.7,73.8 C338.9,72.7 ' +
  '338.4,71.4 337.8,70.2 C337.3,69 336.9,67.7 336.5,66.4 C336.1,65.2 335.7,63.9 335.3,62.6 C334.8,61.4 ' +
  '334.4,60.1 333.8,58.9 C333.3,57.7 332.7,56.5 332,55.4 C331.3,54.3 330.5,53.2 329.6,52.2 C328.7,51.2 ' +
  '327.7,50.3 326.7,49.4 C325.6,48.6 324.5,47.9 323.4,47.2 C322.2,46.5 321.1,45.9 319.8,45.3 C318.6,44.7 ' +
  '317.4,44.2 316.2,43.8 C314.9,43.3 313.6,42.9 312.3,42.6 C311,42.3 309.7,42.1 308.4,41.9 C307.1,41.8 ' +
  '305.7,41.7 304.4,41.6 C303.1,41.6 301.7,41.6 300.4,41.6 C299.1,41.7 297.7,41.8 296.4,41.9 C295.1,41.9 ' +
  '293.7,42.1 292.4,42.2 C291.1,42.3 289.8,42.4 288.4,42.6 C287.1,42.7 285.8,42.9 284.5,43.1 C283.2,43.4 ' +
  '281.9,43.7 280.6,44.1 C279.4,44.6 278.1,45.1 277,45.8 C275.8,46.4 274.7,47.2 273.7,48.1 C272.7,48.9 ' +
  '271.8,49.9 271,51 C270.2,52 269.5,53.2 268.9,54.4 C268.4,55.6 268,56.9 267.6,58.2 C267.3,59.5 267,60.8 ' +
  '266.8,62.1 C266.6,63.4 266.4,64.7 266.2,66.1 C266.1,67.4 265.9,68.7 265.8,70 C265.7,71.4 265.7,72.7 ' +
  '265.6,74 C265.6,75.4 265.5,76.7 265.5,78 C265.5,79.4 265.5,80.7 265.5,82 C265.5,83.4 265.5,84.7 265.5,86 ' +
  'C265.6,87.4 265.6,88.7 265.6,90 C265.6,91.4 265.7,92.7 265.7,94 C265.7,95.4 265.7,96.7 265.7,98 ' +
  'C265.7,99.4 265.7,100.7 265.7,102 C265.6,103.4 265.5,104.7 265.4,106 C265.2,107.3 265,108.7 264.7,109.9 ' +
  'C264.3,111.2 263.9,112.5 263.2,113.7 C262.5,114.8 261.6,115.9 260.6,116.7 C259.6,117.5 258.3,118.1 ' +
  '257.1,118.5 C255.8,118.9 254.4,119 253.1,118.8 C251.8,118.7 250.5,118.3 249.3,117.7 C248.2,117 ' +
  '247.1,116.1 246.3,115.1 C245.4,114.1 244.8,112.9 244.3,111.7 C243.8,110.4 243.5,109.1 243.3,107.8 ' +
  'C243.1,106.5 243,105.1 242.9,103.8 C242.8,102.5 242.8,101.2 242.8,99.8 C242.8,98.5 242.8,97.2 242.8,95.8 ' +
  'C242.9,94.5 242.9,93.2 243,91.8 C243,90.5 243.1,89.2 243.1,87.8 C243.1,86.5 243.2,85.2 243.2,83.8 ' +
  'C243.3,82.5 243.3,81.2 243.3,79.8 C243.3,78.5 243.2,77.2 243,75.8 C242.9,74.5 242.7,73.2 242.5,71.9 ' +
  'C242.2,70.6 241.9,69.3 241.6,68 C241.2,66.7 240.8,65.4 240.3,64.2 C239.9,62.9 239.5,61.7 238.9,60.5 ' +
  'C238.3,59.3 237.7,58.1 236.9,57 C236.2,55.9 235.3,54.8 234.4,53.9 C233.5,52.9 232.4,52.1 231.3,51.3 ' +
  'C230.2,50.6 229.1,49.9 227.9,49.3 C226.7,48.6 225.6,47.9 224.4,47.4 C223.2,46.8 221.9,46.4 220.6,46.1 ' +
  'C219.3,45.8 218,45.7 216.6,45.7 C215.3,45.6 214,45.8 212.6,45.9 C211.3,46 210,46.1 208.6,46.1 ' +
  'C207.3,46.2 206,46.1 204.7,46.1 C203.3,46 202,45.8 200.7,45.6 C199.4,45.4 198.1,45.1 196.7,44.9 ' +
  'C195.4,44.7 194.1,44.5 192.8,44.3 C191.5,44.2 190.1,44.1 188.8,44.1 C187.5,44.2 186.1,44.3 184.8,44.6 ' +
  'C183.5,44.9 182.3,45.4 181.1,45.9 C179.8,46.4 178.6,47 177.4,47.5 C176.1,48 174.9,48.4 173.6,48.9 ' +
  'C172.4,49.4 171.2,49.9 170,50.5 C168.7,51 167.5,51.6 166.4,52.2 C165.2,52.9 164.1,53.7 163.1,54.5 ' +
  'C162,55.3 161.1,56.3 160.2,57.3 C159.3,58.3 158.5,59.4 157.8,60.5 C157.1,61.6 156.4,62.8 155.7,63.9 ' +
  'C155,65 154.3,66.2 153.5,67.2 C152.6,68.2 151.8,69.4 150.6,70 C149.5,70.5 148,70.7 146.8,70.5 ' +
  'C145.6,70.3 144.3,69.6 143.2,68.8 C142.2,68 141.4,66.8 140.6,65.8 C139.9,64.7 139.3,63.4 138.7,62.3 ' +
  'C138.1,61.1 137.5,59.9 136.8,58.7 C136.1,57.6 135.4,56.5 134.5,55.5 C133.7,54.4 132.7,53.5 131.7,52.7 ' +
  'C130.6,51.9 129.5,51.2 128.3,50.6 C127.1,50 125.8,49.6 124.5,49.2 C123.2,48.9 121.9,48.8 120.5,48.7 ' +
  'C119.2,48.7 117.9,48.8 116.6,49 C115.2,49.2 113.9,49.5 112.7,49.9 C111.4,50.3 110.1,50.8 109,51.4 ' +
  'C107.8,52 106.7,52.8 105.6,53.6 C104.6,54.4 103.6,55.4 102.8,56.4 C101.9,57.4 101.2,58.5 100.5,59.7 ' +
  'C99.9,60.8 99.3,62.1 98.8,63.3 C98.3,64.5 98,65.8 97.6,67.1 C97.3,68.4 97.1,69.7 96.8,71 C96.6,72.3 ' +
  '96.5,73.7 96.4,75 C96.3,76.3 96.2,77.7 96.1,79 C96.1,80.3 96,81.7 96,83 C95.9,84.3 95.9,85.7 95.7,87 ' +
  'C95.6,88.3 95.5,89.6 95.2,91 C95,92.3 94.7,93.6 94.2,94.8 C93.7,96 93,97.3 92.1,98.2 C91.3,99.2 ' +
  '90.2,100.1 89,100.7 C87.8,101.2 86.4,101.5 85.1,101.5 C83.9,101.5 82.4,101.1 81.3,100.5 C80.2,100 ' +
  '79.1,99 78.3,98 C77.5,97 76.9,95.7 76.4,94.5 C76,93.2 75.7,91.9 75.5,90.6 C75.3,89.3 75.2,87.9 75,86.6 ' +
  'C74.9,85.3 74.9,83.9 74.8,82.6 C74.7,81.3 74.7,79.9 74.6,78.6 C74.5,77.3 74.4,75.9 74.3,74.6 C74.1,73.3 ' +
  '74,72 73.7,70.7 C73.5,69.4 73.2,68 72.8,66.8 C72.5,65.5 72,64.2 71.5,63 C70.9,61.8 70.3,60.6 69.5,59.5 ' +
  'C68.8,58.4 67.9,57.4 67,56.5 C66,55.5 65,54.7 63.9,53.8 C62.9,53 61.8,52.3 60.6,51.6 C59.5,50.9 ' +
  '58.3,50.3 57.1,49.7 C55.9,49.1 54.7,48.6 53.5,48.1 C52.2,47.6 51,47.1 49.7,46.7 C48.4,46.4 47.1,46 ' +
  '45.8,45.8 C44.5,45.5 43.2,45.3 41.9,45.1 C40.5,45 39.2,44.9 37.9,44.8 C36.5,44.7 35.2,44.7 33.9,44.7 ' +
  'C32.5,44.7 31.2,44.7 29.9,44.7 C28.5,44.7 27.2,44.7 25.9,44.7 C24.5,44.7 23.2,44.7 21.9,44.6 C20.6,44.4 ' +
  '19.2,44.3 17.9,44.1 C16.6,43.9 15.3,43.6 14,43.3 C12.7,42.9 11.4,42.5 10.2,42.1 C8.9,41.6 7.7,41 ' +
  '6.5,40.5 C5.3,39.9 4.1,39.2 3,38.6 C1.9,37.9 0.5,37 0,36.7 Z';

export function HoneyDrip({ top, left, width, height }: { top: number; left: number; width: number; height: number }) {
  const id = useId().replace(/[^a-zA-Z0-9]/g, '');
  if (height <= 0) return null;
  return (
    <div className="honey" aria-hidden="true" data-testid="honey-drip" style={{ top, left, width, height }}>
      <svg viewBox="0 0 400 122" preserveAspectRatio="none">
        <defs>
          <linearGradient id={`${id}fill`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#ffd96b" />
            <stop offset="0.45" stopColor="#ffc83d" />
            <stop offset="1" stopColor="#f0a00c" />
          </linearGradient>
          <linearGradient id={`${id}shine`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#fff" stopOpacity="0" />
            <stop offset="0.5" stopColor="#fff" stopOpacity="0.55" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <clipPath id={`${id}clip`}>
            <path d={HONEY_PATH} />
          </clipPath>
        </defs>
        <g className="honey__body">
          <path d={HONEY_PATH} fill={`url(#${id}fill)`} />
          <g clipPath={`url(#${id}clip)`}>
            {/* reflexo fino logo abaixo da borda de cima e brilho que passa */}
            <rect x="0" y="6" width="400" height="5" fill="#fff" opacity="0.25" />
            <rect className="honey__shine" x="-160" y="0" width="160" height="122" fill={`url(#${id}shine)`} />
          </g>
        </g>
      </svg>
    </div>
  );
}
